import React from "react";
import difference from "lodash/difference";
import {Table, Transfer} from "antd";
import {TransferResponsiveWrapper} from "../styles/UserPage.styled";

const TableTransfer = ({leftColumns, rightColumns, ...restProps}) => (
    <TransferResponsiveWrapper>
        <Transfer {...restProps}>
            {({
                direction,
                filteredItems,
                onItemSelectAll,
                onItemSelect,
                selectedKeys: listSelectedKeys,
                disabled: listDisabled
            }) => {
                const columns = direction === "left" ? leftColumns : rightColumns;
                const rowSelection = {
                    getCheckboxProps: item => ({
                        disabled: listDisabled || item.disabled
                    }),
                    onSelectAll(selected, selectedRows) {
                        const treeSelectedKeys = selectedRows
                            .filter(item => !item.disabled)
                            .map(({key}) => key);
                        const diffKeys = selected
                            ? difference(treeSelectedKeys, listSelectedKeys)
                            : difference(listSelectedKeys, treeSelectedKeys);
                        onItemSelectAll(diffKeys, selected);
                    },
                    onSelect({key}, selected) {
                        onItemSelect(key, selected);
                    },
                    selectedRowKeys: listSelectedKeys
                };
                // tableLayout="fixed" + sabit sütun genişlikleri, uzun açıklamaların satır
                // içinde kalıp alt satıra sarmasını sağlar. "max-content" scroll bunun yerine
                // metni tek satırda ölçüp tabloyu container'ın dışına taşırıyordu.
                return (
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={filteredItems}
                        size="small"
                        tableLayout="fixed"
                        scroll={{x: 600}}
                        style={{
                            pointerEvents: listDisabled ? "none" : undefined
                        }}
                        onRow={({key, disabled: itemDisabled}) => ({
                            onClick: () => {
                                if (itemDisabled || listDisabled) return;
                                onItemSelect(key, !listSelectedKeys.includes(key));
                            }
                        })}
                    />
                );
            }}
        </Transfer>
    </TransferResponsiveWrapper>
);

export default TableTransfer;
